/*
 * FH 2026-09-28: the X on the phone filter panel didn't close it.
 * Our filter template's X calls globofilter.toggleCanvas() itself (onclick), and an update to the Smart Product
 * Filter app now also calls it for any tap on .gf-close-canvas, so one tap closed the panel and opened it again.
 * This takes the tap first and toggles exactly once, whichever of the two is present. Keyboard use (Enter, Space,
 * Escape) is handled separately in ada-a11y-fixes.js and is unchanged.
 * Rollback: delete the fh-filter-close line in snippets/meta-tags.liquid.
 */
(function () {
  'use strict';
  if (window.__fhFilterClose) return;
  window.__fhFilterClose = true;
  document.addEventListener('click', function (e) {
    var x = e.target && e.target.closest && e.target.closest('#gf-tree .gf-close-canvas');
    if (!x) return;
    e.preventDefault();
    e.stopPropagation();
    if (window.globofilter && typeof window.globofilter.toggleCanvas === 'function') window.globofilter.toggleCanvas();
  }, true);
})();